var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main page-btns" },
    [
      _c("page-title"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-msg" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 18 } }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "0.14rem",
                      color: "rgba(0, 0, 0, 0.65)",
                      "line-height": "1.5em",
                    },
                  },
                  [_vm._v("\n          Rep Balance\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "0.3rem",
                      color: "#000",
                      "line-height": "1.5em",
                      "font-weight": "600",
                    },
                  },
                  [
                    _c("big-number", { attrs: { number: _vm.balance } }),
                    _vm._v("Rep\n        "),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", [
            _c(
              "div",
              { staticStyle: { "font-size": ".16rem", color: "#929dad" } },
              [
                _vm._v("\n        Haven't added the token? "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: { click: _vm.addRepTokenToWallet },
                  },
                  [_vm._v("Add it to your wallet")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "page_con", staticStyle: { margin: "0.2rem auto" } },
            [
              _c("div", { staticClass: "first" }, [
                _vm._v("\n        Cumulative Minted Rep:\n        "),
                _c("span", [_vm._v(_vm._s(_vm.totalMinted))]),
                _vm._v("\n        Rep\n      "),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "page-card",
            { staticClass: "no-padding", attrs: { noHead: true } },
            [
              _c(
                "div",
                {
                  staticClass: "page-table",
                  attrs: { slot: "body" },
                  slot: "body",
                },
                [
                  _c("div", { staticClass: "spaceBetween search-box" }, [
                    _c("span", { staticClass: "search-title" }, [
                      _vm._v("Deposit details"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "spaceLeft search-form" },
                      [
                        _c("search-date-time", {
                          ref: "date",
                          attrs: { label: "Date" },
                          on: {
                            valChange: function ($event) {
                              return _vm.valChange($event, [
                                "dateFrom",
                                "dateTo",
                              ])
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("search-select", {
                          ref: "type",
                          attrs: { label: "Type", options: _vm.typeList },
                          on: {
                            valChange: function ($event) {
                              return _vm.valChange($event, "type")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { padding: "0rem" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { align: "center", data: _vm.tableData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "timestamp",
                              align: "center",
                              label: "Date",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", {}, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("time")(
                                              row.timestamp,
                                              "yyyy-MM-DD"
                                            )
                                          )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "type",
                              label: "Type",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          row.type === 1 ? "Income" : "Expense"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "Event" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.getReasonVal(row.reason)) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "amount",
                              label: " Amounts（Rep）",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("NumberCom", {
                                      attrs: { number: row.amount },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "tnEthAccount",
                              label: "Receipts Account",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.tnEthAccount
                                      ? _c("account", {
                                          attrs: { value: row.tnEthAccount },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      total: _vm.total,
                      page: _vm.queryParams.page,
                      limit: _vm.queryParams.pageSize,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.queryParams, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.queryParams, "pageSize", $event)
                      },
                      pagination: function ($event) {
                        return _vm.getList()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "ETH/BTC Rep", visible: _vm.open, width: "5rem" },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-position": "top" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "ETH Block number" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }